/**
@format
@flow
*/
import * as React from 'react';
import styled from 'styled-components';
import { Heading } from '@ziynx/components/typography';
import Colors from '@ziynx/theme/colors';
import type { TextStatementType } from '@ziynx/flow-types/statements';

const { BrandCyan, PrimaryBlue, BrandBlueVeryDark } = Colors;

const colors = [BrandCyan, PrimaryBlue, BrandBlueVeryDark];

type Props = $ReadOnly<{
    data?: Array<TextStatementType>,
    children?: any,
}>;

const TextWrapper = styled.div`
`;

const TextStatement = ({
  data = [],
  children,
}: Props): React$Node => {
  let currentColorIndex = 0;

  const _renderComponent = (item: TextStatementType, index: number): React$Node => {
    const {
      value, _id, type, color,
    } = item;
    const currentColor = colors[currentColorIndex] || colors[colors.length - 1];

    if (type === 'string') {
      return (
        <Heading key={_id ? `${_id}${index}` : index} large color={color} primitive="span">
          {value}
        </Heading>
      );
    }
    if (!color) currentColorIndex += 1;
    return (
      <Heading key={_id ? `${_id}${index}` : index} large color={color || currentColor} primitive="span">
        {value}
      </Heading>
    );
  };
  return (
    <TextWrapper>
      <Heading large primitive="span">“</Heading>
      {!!data?.length && data.map(_renderComponent)}
      {!!children && <Heading large primitive="span">{children}</Heading>}
      <Heading large primitive="span">”</Heading>
    </TextWrapper>
  );
};

export default TextStatement;
